import { Action, createFeatureSelector, createSelector } from '@ngrx/store';
import { RunningActionState } from './running-action.state';

export const selectRunningActionState = createFeatureSelector<RunningActionState>('runningActions');

export const isLoading = (actions: Action[]) => createSelector(
    selectRunningActionState,
    state => state.actions && state.actions.length > 0
        && state.actions.find(ra => actions.find(a => a.type.replace(/\s/g, '') === ra) !== undefined) !== undefined,
);
